import division0 from "../assets/division-0.png";
import division1 from "../assets/division-1.png";
import division2 from "../assets/division-2.png";
import division3 from "../assets/division-3.png";
import division4 from "../assets/division-4.png";
import division5 from "../assets/division-5.png";

export const divisions: Record<
  number,
  {
    logo: string;
    name: string;
    address: string;
    telno: string;
  }
> = {
  0: { logo: division0, name: "ABD Office Solutions", address: "1837 California Ave., Corona, CA 92881", telno: "714-255-0505" },
  1: { logo: division1, name: "Printer Copier Guys", address: "1837 California Ave., Corona, CA 92881", telno: "760-250-8037" },
  2: { logo: division2, name: "D&A", address: "1837 California Ave., Corona, CA 92881", telno: "" },
  3: { logo: division3, name: "Reliable Workplace Solutions", address: "1837 California Ave., Corona, CA 92881", telno: "714-367-0033" },
  4: { logo: division4, name: "Tangerine Office Machine", address: "4945 Wilbur St., Las Vegas, NV 59119", telno: "702-820-4029" },
  5: { logo: division5, name: "Central Printer Resources (CPR)", address: "4599 E. Ramon Rd. Palm Springs, CA 92264", telno: "760-778-4444" },
};